import React from "react";
import Grid from "@material-ui/core/Grid";
import MyPagination from "Components/MyPagination";
import Layout from "../Layout";
import {
  fromMonthly,
  toMonthly,
  fromDaily,
  toDaily,
  fromHourly,
  toHourly,
  fromDetail,
  toDetail,
} from "fuction/date";
import { withRouter } from "react-router";
import queryString from "query-string";
import Media from "Components/Media";
import OrderSelect from "Components/OrderSelect";
import MediaSelect from "Components/MediaSelect";
import DatePickers from "Components/DatePickers";
import DateSinglePicker from "Components/DateSinglePicker";
import DateTimePicker from "Components/DateTimePicker";
import useAuth from "Hooks/useAuth";
import useApi from "Hooks/useApi";
import useFilter from "Hooks/useFilter";
import { makeStyles } from "@material-ui/core/styles";
import { animateScroll as scroll } from 'react-scroll';
import googleAnalytics from "fuction/googleAnalytics";
import Toolbar from '@material-ui/core/Toolbar';
import { useQueryString, modQueryPageNum, getQueryPageNum } from "Hooks/useQueryString";

const useStyles = makeStyles((theme) => ({
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(3),
    minWidth: 120,
  },
  sticky: {
    position: "-webkit-sticky", /* safari対応 */
    position: "sticky",
    top: 64,
    zIndex: 1,
    backgroundColor: "white",
    paddingLeft: 90,
    paddingRight: 90,
    width: "100%",
  },
}));

function Page(props) {
  const auth = useAuth();
  const filter = useFilter();
  const classes = useStyles();
  const queryParams = useQueryString();
  const activeMediaGroup = auth.state.activeMediaGroup;

  // 時間間隔を取得
  // 5m minutes / 1h hourly / 1day daily / 1month monthly
  const interval = queryString.parse(props.location.search).interval;
  const date = queryString.parse(props.location.search).date;
  const [page, setPage] = React.useState(getQueryPageNum(queryParams));
  const [totalCount, setTotalCount] = React.useState(0);
  const [order, setOrder] = React.useState("desc");
  const [medias, setMedias] = React.useState([]);
  const [mediaTypes, setMediaTypes] = React.useState([]);
  const [mediaType, setMediaType] = React.useState(
    queryString.parse(props.location.search).type);
  const { request, convertQueryParam } = useApi();

  const scrollToTop = () => {
    scroll.scrollToTop();
  }

  let fromDate = "";
  let toDate = "";
  if (interval && interval != "") {
    switch (interval) {
      case "monthly":
        fromDate = fromMonthly(filter.state.filteredDateFrom);
        toDate = toMonthly(filter.state.filteredDateTo);
        break;
      case "daily":
        fromDate = fromDaily(date);
        toDate = toDaily(date);
        break;
      case "hourly":
        fromDate = fromHourly(date);
        toDate = toHourly(date);
        break;
      case "minutes":
        fromDate = fromDetail(date);
        toDate = toDetail(date, 5);
        break;
      default:
        break;
    }
  }

  const handleChangeDateSingle = (date) => {
    props.history.push(`/media/dashboard/details?activeMediaGroup=${activeMediaGroup}&date=${date}&interval=${interval}&type=${mediaType}`);
  };

  const handleDateChange = (dateTime) => {
    props.history.push(`/media/dashboard/details?activeMediaGroup=${activeMediaGroup}&date=${dateTime}&interval=${interval}&type=${mediaType}`);
  };

  // 他メディア情報を取得
  const rquestMedias = () => {
    // 戻るボタンやURL直貼りで遷移してきたとき、queryParams と auth.state の activeGroup が食い違っていても、
    // 初回レンダでは state の activeGroup （デフォルトグループ）でリクエストして返されたデータで画面表示されてしまう。
    // Layout.js で queryParams と auth.state の activeGroup の同期をとったあとで走る再レンダ時のリクエストで
    // 後からデータを取得しても画面に反映されない（set○○(●●)までで再々レンダは走らない）ので、
    // 同期前で食い違いがあるうちはリクエストしない。
    const activeMediaGroup = queryParams.get("activeMediaGroup");
    if (activeMediaGroup && auth.state.activeMediaGroup !== parseInt(activeMediaGroup, 10)) {
      return;
    }

    const params = {
      range: [fromDate, toDate],
      order: order,
      pagination: {
        page: page,
        limit: 50,
      },
    };

    if (mediaType != "null") {
      params.type = mediaType;
    }

    request({
      method: "GET",
      url: `data/:account_id/media/messages/${
        auth.state.activeMediaGroup
      }?${convertQueryParam(params)}`,
    }).then((data) => {
      setMedias(data.data);
      setMediaTypes(data.meta.types);
      setTotalCount(data.meta.total_count);
      scrollToTop()
    });
  }

  // 初回レンダリングフラグ
  const isFirstRender = React.useRef(false);
  React.useEffect(() => {
    isFirstRender.current = true;
  }, [])

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  React.useEffect(() => {
    // 初回レンダー判定
    if(isFirstRender.current) { 
      // 初回レンダーではないように
      isFirstRender.current = false;
    } else {
      rquestMedias();
    }
  }, [page]);

  const syncQueryPageNum = (...[pn]) => {
    if ((pn && pn === 1) || (totalCount > 0 && (Math.ceil(totalCount / 50)) < getQueryPageNum(queryParams))) {
      modQueryPageNum(queryParams, 1);
      props.history.push(props.location.pathname + "?" + queryParams.toString());
      setPage(1);
    }
    else {
      setPage(getQueryPageNum(queryParams));
    }
  }

  React.useEffect(() => {
    if (auth.state.activeMediaGroup === 0) {
      return;
    }

    if (page === 1) {
      rquestMedias();
    } else {
      syncQueryPageNum(1);
    }
  }, [auth.state.activeMediaGroup, filter.state, mediaType, order, fromDate, toDate]);

  const HeadDate = () => {
    if (interval === "monthly") {
      return (
        <DatePickers
          onChange={{}}
          mediaFlag={true}
        />
      );
    }
    if (interval === "daily") {
      return (
        <DateSinglePicker
          date={fromDate}
          onChange={(date) => handleChangeDateSingle(date)}
          mediaFlag={true}
        />
      );
    }
    if (interval === "hourly" || interval === "minutes") {
      return (
        <DateTimePicker
          dateTime={fromDate}
          handleDateChange={handleDateChange}
          step={interval}
          mediaFlag={true}
        />
      );
    }
  };

  if (page !== getQueryPageNum(queryParams)) {
    syncQueryPageNum();
  }
  return (
    <Layout
      content={
        <Grid container spacing={3}>
          <Toolbar className={classes.sticky}>
            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                alignItems="flex-end"
                justifyContent="flex-start"
              >
                <HeadDate />
                <div className={classes.divider}></div>
                <MediaSelect
                  mediaTypes={mediaTypes}
                  handleChangeMediaSelect={(value) => {
                    setMediaType(value);
                  }}
                  value={mediaType}
                />
                <div className={classes.divider}></div>
                <OrderSelect
                  handleChangeOrderSelect={(value) => {
                    setOrder(value);
                  }}
                  value={order}
                />
              </Grid>
              <Grid container spacing={3} className={classes.formControl} justifyContent="center">
                <MyPagination
                count={Math.ceil(totalCount / 50)}
                currentPage={page}
                handlePagination={(page) => setPage(page)}
                />
              </Grid>
            </Grid>
          </Toolbar>
          <Grid item xs={12}>
            {medias.map((row, index) => (
              <Media key={index} row={row} types={mediaTypes} order={order} />
            ))}
          </Grid>
        </Grid>
      }
    />
  );
}

export default withRouter(Page);
